import React, { FC, ReactElement } from 'react';
import cns from 'classnames';
import './Partners.sass';
import { useSelector } from 'react-redux';
import { getContentDataPartners } from '../../../../stores/reducers/userData';
import { internalizationState } from '../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../helpers/locale-field-finder';

interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;
}

const Partners: FC<Props> = ({ className, bgSettings, sectionName, sectionId }): ReactElement => {
  const { backendURL, partners } = useSelector(getContentDataPartners);
  const { activeLangState } = useSelector(internalizationState);

  const renderPartner = (p: any, isPrimary = false) => (
    <>
      <div className="partner-label-wrapp">
        {p.color ? (
          <span className="label-info" style={{ backgroundColor: p.color }}>
            {localeFieldResolver(p, 'label', activeLangState)}
          </span>
        ) : (
          <span className={cns('label-info', isPrimary ? 'label-info--primary' : 'label-info--extra')}>{localeFieldResolver(p, 'label', activeLangState)}</span>
        )}
      </div>
      <img src={`${backendURL}${p.image}`} alt={localeFieldResolver(p, 'title', activeLangState)} />
    </>
  );

  const renderPartners = (ps: any, isPrimary = false) =>
    ps.map((partner: any, ind: any) => (
      <li key={ind} className="partner-item">
        {partner.link ? (
          <a href={partner.link} target="_blank" rel="noopener noreferrer">
            {renderPartner(partner, isPrimary)}
          </a>
        ) : (
          renderPartner(partner, isPrimary)
        )}
      </li>
    ));

  return (
    <section
      className={cns(
        'inner-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        'section-partners',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="container" id={sectionId}>
        <div className="inner-section__head">
          <div className="section-title">{sectionName}</div>
        </div>
        {partners && (
          <>
            <ul className="partners-list partners-list--ultra">
              {renderPartners(
                partners.filter((p: any) => p.size === 'ultra'),
                true
              )}
            </ul>
            <ul className="partners-list">
              {renderPartners(
                partners.filter((p: any) => p.size === 'big'),
                true
              )}
            </ul>
            <ul className="partners-list partners-list--medium">
              {renderPartners(partners.filter((p: any) => p.size === 'medium'))}
            </ul>
            <ul className="partners-list partners-list--mini">
              {renderPartners(partners.filter((p: any) => p.size === 'small'))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
};

export default Partners;
